import { useParams } from "react-router-dom";

export const useId = () => {
  const {id} = useParams()
  if (!id) {
    throw new Error("'id' not passed")
  }
  return id
}
